export default {
  current: (state) => {
    return state.current
  },

  active: (state) => {
    return (state.selected !== null)
  },

  all: (state, getters, rootState) => {
    return JSON.parse(JSON.stringify(rootState.tracks))
  },

  single: (state, getters, rootState) => {
    let results = false
    try {
      results = rootState.tracks.length === 1
    }
    catch (e) { console.log(e) }
    return results
  },

  transfers: (state) => {
    const filterForResponses = state.current.multiUsePanels
    const filtered = state.current.panels.filter(x => filterForResponses.includes(x.collections))
    const result = []
    filtered.forEach(panel => {
      let response = panel.responses.find(x => x.selected)
      if (response) {
        result.push({
          name: panel.name,
          value: response.value
        })
      }
    })
    return JSON.parse(JSON.stringify(result))
  },

  responseTokens: (state, getters, rootState, rootGetters) => {
    let results = {}

    let allPanels = rootGetters['v4/language/responses']
    allPanels = allPanels.concat(rootGetters['v4/preference/all'])

    if (getters.active) {
      allPanels = allPanels.concat(state.current.panels)
    }

    allPanels.forEach(panel => {
      panel.responses.forEach(response => {

        let token
        const responseTokenOverride = panel.options?.responseTokenOverrides?.[response.name]

        if (responseTokenOverride) {
          token = responseTokenOverride
        }
        else if (panel.options?.confirmValueInSummary) {
          token = `generic.confirm`
        }
        else if (panel.type === 'lookup') {
          token = `${response.name}.${response.value}`
        }
        else if (panel.options?.overrideGenericToken?.includes(response.value)) {
          token = response.name
        }
        else if (['yes', 'no', 'unknown'].includes(response.value)) {
          token = `generic.${response.value}`
        }
        else if (panel.type === 'multiple' && !panel.options?.getResponsesFromTokens) {
          token = response.value
        }
        else {
          token = response.name
        }

        results[response.name] = responseTokenOverride ? token : `responses.${token}.title`

      })
    })

    return results
  },

  conditions: (state, getters, rootState) => {
    let results = []
    try {
      results = getters.current.diseases.map(condition => {
        return {
          type: 'condition',
          ...condition
        }
      })
    } catch (e) {}
    return results
  },

  classifications: (state, getters, rootState) => {
    let results = []
    try {
      const classifications = { 
        patient: getters.current.classifications?.patient || getters.current.path,
        audience: getters.current.classifications?.audience || getters.current.target_audience,
        experience: getters.current.classifications?.experience || 'pwa',
      }

      results = Object.keys(classifications).map(key => ({
        type: 'classification', 
        name: key, 
        value: classifications[key],
      }))
    } catch (e) {}

    return results
  },

  settings: (state, getters) => (name) => {
    let result
    try {
      if (['audience', 'patient'].includes(name)) {
        result = getters.classifications.find(c => c.name === name).value
      }

      const track = getters.current
      if (track.options?.name) {
        result = track.options[name]
      }
    } catch (e) {
      console.log(e)
    }
    return result
  },

  promptType: (state, getters) => {
    switch (getters.settings('patient')) {
      case 'newborn':
      case 'child':
        return 'prompt_3p';
      default:
        return 'prompt';
    }
  },

  clickedSave: (state) => {
    return state.clickedSave
  },

  editResponsesMode: ( state ) => {
    return state.editResponsesMode
  },

  editingFollowupResponses: ( state ) => {
    return state.editingFollowupResponses
  },

  streamlinedOptions: ( state ) => {
    return state.streamlinedOptions
  },

  filterConditions: ( state ) => {
    return state.filterConditions
  },

  selectedStreamlinedOptions: ( state ) => {
    return state.streamlinedOptions.filter(s => s.selected).map(s => s.value)
  },

  streamlinedOptionsDataSave: ( state ) => {
    return state.streamlinedOptions.map(s => {
      let status = 'not_selected'
      if (s.preselect) {
        status = 'preselected'
      } else if (s.selected) {
        status = 'selected'
      }
      return { name: s.value, status }
    })
  }
}
